<template lang="pug">
  .system-permission-container
    .header 为向您提供更好的用户体验，哈啰在特定场景可能需要向您申请获取以下手机系统权限
    .content-scroll
      .system-config.content(v-for='item in systemPermission' :key='item.guid')
          .item
            .left
              img(
                :src='item.icon'
              )
            .right
              .title {{ item. title}}
              .text {{ item.content }}
      .end-text - 哈啰 -
    .bottom-content
      .title-info(@click='setUp')
        img.icon(
          src='https://m.hellobike.com/resource/helloyun/wb15250/-lbi02WioW.png?x-oss-process=image/quality,q_80'
        )
        span 点此进行系统设置
      .info 您可以随时在手机上通过相关设置，进行权限的授予与收回
      .safe-area(
        v-if='isEasyBikeApp'
      )
</template>

<script>
import { env, Native } from '@hb/NBridge/lib/h5';
import { isPreRender } from '@/utils';
import { SYSTEM_PERMISSION_LIST } from '@/const/system-permission';

export default {
  computed: {
    isEasyBikeApp() {
      if (env.isEasyBikeApp) {
        return true;
      }
      return false;
    },
    systemPermission() {
      return SYSTEM_PERMISSION_LIST || [];
    },
  },
  async mounted() {
    if (isPreRender()) {
      document.dispatchEvent(new Event('render-event'));
    }
  },
  methods: {
    setUp() {
      let method = '';
      if (env.isIOS) {
        method = 'goSetting';
      } else if (env.isAndroid) {
        method = 'openSystemSettingPage';
      }
      Native.callNative({
        method,
        classMap: 'business/user',
        params: {},
        timeout: false,
      });
    },
  },
};
</script>

<style lang="less" scoped>
  .system-permission-container {
    width: 100%;
    overflow: hidden;

    .content-scroll {
      padding-top: 0.68rem;
      overflow-y: scroll;
    }

    .header {
      position: fixed;
      padding: 0.12rem 0.16rem;
      height: 0.68rem;
      font-size: 0.13rem;
      font-weight: 400;
      color: #879099;
      line-height: 0.22rem;
      background: #f0f3f5;
    }

    .system-config.content {
      width: 100%;
      background: #fff;

      .item {
        padding-top: 0.16rem;
        padding-left: 0.16rem;
        display: flex;

        img {
          width: 0.26rem;
          height: 0.26rem;
        }

        .right {
          flex: 1;
          margin-left: 0.08rem;

          .title {
            height: 0.26rem;
            line-height: 0.26rem;
            font-size: 0.16rem;
            font-weight: 500;
            color: #242729;
          }

          .text {
            margin-top: 0.08rem;
            padding-right: 0.12rem;
            padding-bottom: 0.16rem;
            font-size: 0.13rem;
            font-weight: 400;
            color: #879099;
            line-height: 0.18rem;
          }
        }
      }

      & .item:not(:last-of-type) .right {
        border-bottom: 0.01rem solid #f0f3f5;
      }
    }

    .end-text {
      padding-top: 0.15rem;
      text-align: center;
      font-size: 0.13rem;
      font-weight: 500;
      color: #d3dae0;
      line-height: 0.22rem;
      background: #f0f3f5;
      height: 1.66rem;
    }

    .bottom-content {
      width: 100%;
      position: fixed;
      bottom: 0;
      padding-top: 0.08rem;
      background: #fff;
      display: flex;
      flex-direction: column;
      align-items: center;
      box-shadow: 0 -0.04rem 0.16rem 0 rgba(36, 39, 41, 0.08);
      border-radius: 0.12rem 0.12rem 0 0;
      overflow: hidden;

      .title-info {
        height: 0.25rem;
        font-size: 0.18rem;
        font-weight: 500;
        color: #08f;
        line-height: 0.25rem;
        display: flex;
        align-items: center;

        .icon {
          width: 0.22rem;
          height: 0.22rem;
          margin-right: 0.05rem;
        }
      }

      .info {
        margin-top: 0.08rem;
        height: 0.17rem;
        font-size: 0.12rem;
        font-weight: 400;
        color: #5a6066;
        line-height: 0.17rem;
      }

      .safe-area {
        padding-bottom: constant(safe-area-inset-bottom);
        padding-bottom: env(safe-area-inset-bottom);
        height: 0.2rem;
      }
    }
  }
</style>
